export const GROUP_ACCESS_DRAWER_TAB_KEYS = {
  DATA_CONNECTIONS: "dataConnections",
  PAGE_ACCESS_CONTROL: "pageAccessControl",
};

export const GROUP_ACCESS_DRAWER_TABS = [
  {
    value: GROUP_ACCESS_DRAWER_TAB_KEYS.DATA_CONNECTIONS,
    label: "Data Connections",
  },
  {
    value: GROUP_ACCESS_DRAWER_TAB_KEYS.PAGE_ACCESS_CONTROL,
    label: "Entitlements",
  },
];

export const GROUPS_FACILITIES_PICKER = {
  DEFAULT_PAGE: 0,
  PAGE_SIZE: 50,
  SEARCH_DEBOUNCE_MS: 250,
  LISTBOX_SCROLL_THRESHOLD_PX: 24,
};

export const GROUP_ID_TYPES = {
  customerId: "Customer ID",
  groupId: "Group ID",
};

export const TAG_SOURCE_CONNECTORS = {
  MQTT_SPB: "mqtt-spb",
  HACHWIMS: "hachwims",
};

const GROUPS_CONSTANTS = {
  createGroupLables:{
    CUSTOMER_NAME: "Customer Name",
    TIME_ZONE: "Time Zone",
    GROUP_ID: "Customer ID"
  },
  createGroupButtons:{
    SAVE : "Save",
    CANCEL: "Cancel"
  },
  breadcrumb: {
    CUSTOMER_OVERVIEW: "Customer Overview",
    CREATE_CUSTOMER: "Create Customer"
  },
  alert: {
    TITLE: "Alert",
    CUSTOMER_CREATED_SUCCESS: "Customer created successfully"
  },
  toast: {
    TYPE_SUCCESS: "success",
    TYPE_FAILURE: "failure",
    TITLE_SUCCESS: "Success",
    TITLE_FAILED: "Failed",
    DURATION: 10000,
    MESSAGE_FAILURE: "Please try again after some time",
  },
  navigation: {
    CUSTOMERS_PATH: "/customers",
    CREATE_CUSTOMER_PATH: "/createcustomer",
  },
  groupsList: {
    TITLE: "Customer Overview",
    ADD_NEW_CUSTOMER: " Add New Customer",
    SEARCH_PLACEHOLDER: "Search Group..",
    ACTIVATE_CUSTOMER: "Activate Customer",
    DEACTIVATE_CUSTOMER: "Deactivate Customer",
    ACTIVATE_CONFIRM_MESSAGE: "Are you sure you want to activate this Customer?",
    DEACTIVATE_CONFIRM_MESSAGE: "You are about to deactivate 1 customer. This action will affect all associated data.\n\nAre you sure you want to proceed?",
    BUTTON_ACTIVATE: "ACTIVATE",
    BUTTON_DEACTIVATE: "DEACTIVATE",
    ARIA_LABEL_VIEW_GROUP: "View Group",
    ARIA_LABEL_EDIT_GROUP: "Edit Group",
    DATA_CONNECTIONS_UPDATE_SUCCESS: "Updated successfully",
  },
  addEditGroup: {
    CREATE_NEW_CUSTOMER: "Create New Customer",
    UPDATE_CUSTOMER: "Update Customer",
    CUSTOMER_PREVIEW: "Customer Preview",
    EDIT_CUSTOMER: "Edit Customer",
    CUSTOMER_EDIT: "Customer Edit",
    CUSTOMER_LABEL: "Customer: ",
    ACTIVE_LABEL: "Active",
    ACTIVATE_KAFKA_TOPIC: "Activate Kafka Topic",
    DEACTIVATE_KAFKA_TOPIC: "Deactivate Kafka Topic",
    ACTIVATE_TOPIC_CONFIRM: "Are you sure you want to activate this topic?",
    DEACTIVATE_TOPIC_CONFIRM: "Are you sure you want to deactivate this topic?",
    KAFKA_TAB_KEY: "Kafka",
    KAFKA_TAB_TITLE: "KAFKA TOPICS",
    SCHEMAS_TAB_KEY: "Schemas",
    SCHEMAS_TAB_TITLE: "SCHEMAS",
    TOPIC_ACTIVE_ALT: "Topic Active",
    TOPIC_INACTIVE_ALT: "Topic InActive",
  },
  groups: {
    NO_CUSTOMERS_FOUND: "No customers found",
    TOAST_ERROR_TITLE: "Error",
  },
  groupAccessDrawer: {
    TAB_KEYS: GROUP_ACCESS_DRAWER_TAB_KEYS,
    TABS: GROUP_ACCESS_DRAWER_TABS,
    COLUMN_HEADERS: {
      MODULE_NAME: "Module Name",
      ACCESS: "Access",
    },
    ACCESS_COLUMN_TOOLTIP: "Turn off module access for the selected customer",
    APPLY: "Apply",
    DATA_CONNECTIONS: {
      MQTT_SPB_TITLE: TAG_SOURCE_CONNECTORS.MQTT_SPB,
      MQTT_SPB_FIELD_LABEL: "Group ID",
      MQTT_SPB_PLACEHOLDER: "Group ID",
      MQTT_SPB_ARIA_LABEL: TAG_SOURCE_CONNECTORS.MQTT_SPB,
      MQTT_SPB_TOGGLE_ARIA: "Enable or disable mqtt-spb group id",
      HACHWIMS_TITLE: TAG_SOURCE_CONNECTORS.HACHWIMS,
      HACHWIMS_FIELD_LABEL: "Facility/Plant",
      HACHWIMS_PLACEHOLDER: "Facility/Plant",
      HACHWIMS_ARIA_LABEL: TAG_SOURCE_CONNECTORS.HACHWIMS,
      HACHWIMS_TOGGLE_ARIA: "Enable or disable hachwims facilities",
    },
  },
  loading: {
    FALLBACK: "Loading...",
  },
  createGroupErrorMessages: {
    groupId: "Only alphanumeric characters, dash (-) and underscore (_) are allowed",
    idTooShort: "{idType} must be at least 3 characters.",
    idTooLong: "{idType} cannot exceed 20 characters.",
    idDuplicate: "{idType} already exists",
    idRequired: "A {idType} is required",
    name: "Customer already exists",
    nameRequired: "Customer Name is required",
    timeZoneRequired: "Time Zone is required",
    facilitiesRequired: "Select atleast one facility to proceed",
  },
  createGroup: {
    ERROR_TYPE_REQUIRED: "required",
    ERROR_TYPE_MANUAL: "manual",
  }
}

export default GROUPS_CONSTANTS;